<template>
    <b-modal ref="mdlEditSpeseExtra" id="mdlEditSpeseExtra" :title="title" size="lg" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Descrizione</label>
                <b-form-input v-model="jsonDataSpeseExtra.descrizione"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Importo</label>
                <b-form-input v-model="jsonDataSpeseExtra.importo"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Natura Economica</label>
                <!-- <b-form-input v-model="jsonDataSpeseExtra.naturaEconomica"></b-form-input> -->
                <b-form-select v-model="jsonDataSpeseExtra.codiceIva" :options="codiceIvaOptions" :value="''" value-field="codiceIva" text-field="descrizioneIva" @change="onCodiceIvaChange">
                    <template #first>
                        <b-form-select-option :value="null" disabled> - Seleziona Natura Economica -</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Aliquota IVA</label>
                <b-form-input v-model="aliquotaIva" value-field="aliquotaIva" text-field="aliquotaIva" readonly />
            </b-col>
            <b-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <b-form-checkbox v-model="jsonDataSpeseExtra.spesaRicorsiva" name="check-button" switch> Spesa Ricorsiva </b-form-checkbox>
            </b-col>
            <b-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <b-form-checkbox v-model="jsonDataSpeseExtra.importoLibero" name="check-button" switch> Importo Libero </b-form-checkbox>
            </b-col>
            <b-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <b-form-checkbox v-model="jsonDataSpeseExtra.includiFattura" name="check-button" switch> Includi in Fattura </b-form-checkbox>
            </b-col>
            <b-col cols="12" xs="12" sm="3" md="3" lg="3" xl="3">
                <b-form-checkbox v-model="jsonDataSpeseExtra.nonAggregare" name="check-button" switch> Non Aggregare </b-form-checkbox>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonDataSpeseExtra.note" rows="3" max-rows="7"> </b-form-textarea>
            </b-col>
        </b-row>

        <template #modal-footer>
            <b-button @click="onClickCloseModal" variant="outline-danger" size="md">Annulla </b-button>
            <b-button @click="onClickSaveSpesaExtra" variant="outline-success" size="md">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            isNew: true,
            pathResource: "/rsaspeseextra",
            /* pathResourceNatureEconomiche: "/rsaspeseextranaturaeconomica", */
            pathResourceTabellaIVA: "/tabellaiva",
            aliquotaIva: 0,
            // natureEconomicheOptions: [],
            codiceIvaOptions: [],
            jsonDataSpeseExtra: {
                id: null,
                descrizione: null,
                naturaEconomica: "",
                codiceIva: null,
                descrizioneIva: null,
                spesaRicorsiva: false,
                importoLibero: false,
                includiFattura: false,
                nonAggregare: false,
                note: null,
            },
        };
    },
    mounted() {
        let me = this;
        me.loadTabellaIva();
    },
    methods: {
        /* me.loadNatureEconomiche(); */
        // me.$refs.mdlEditSpeseExtra.show();
        // },
        /* loadNatureEconomiche() {
            let me = this;
            // me.UtilityMixin.methods.
            UtilityMixin.methods.loadDataResources(me.pathResourceNatureEconomiche, null, me.loadNatureEconomicheSuccess, me.loadNatureEconomicheError);
        },
        loadNatureEconomicheSuccess(response) {
            let me = this;
            me.natureEconomicheOptions = response.data.data.list;
            me.natureEconomicheOptions.unshift({ codice: "", descrizione: "-Seleziona Valore-" });
            // me.rows = response.data.data.length;
            // this.showModalLoading = true;
        },
        loadNatureEconomicheError(response) {
            console.log(response);
        }, */

        show(jsonData) {
            let me = this;
            me.jsonDataSpeseExtra = jsonData;
            me.title = !jsonData.id ? "Nuova Spesa Extra" : "Aggiorna Spesa Extra";
            me.$refs.mdlEditSpeseExtra.show();
        },

        loadTabellaIva() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTabellaIVA, null, me.loadTabellaIvaSuccess, me.loadTabellaIvaError);
        },
        loadTabellaIvaSuccess(response) {
            let me = this;
            me.codiceIvaOptions = response.data.data;
        },
        loadTabellaIvaError(response) {
            console.log(response);
        },

        onClickCloseModal() {
            let me = this;
            me.jsonDataSpeseExtra = {};
            me.aliquotaIva = 0;
            me.$refs.mdlEditSpeseExtra.hide();
            me.$emit("closeModal");
            // console.log("jsonData: ", this.jsonDataSpeseExtra);
        },

        onClickSaveSpesaExtra() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataSpeseExtra, me.saveSuccessResponse, me.saveErrorResponse);
        },

        saveSuccessResponse(response) {
            let me = this;
            me.$emit("onSave", response);
            me.$refs.mdlEditSpeseExtra.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },

        onDeleteSpesaExtra(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Spesa Extra",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteSpesaExtra(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        deleteSpesaExtra(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteSpesaExtraSuccess, me.deleteSpesaExtraError);
        },
        deleteSpesaExtraSuccess(response) {
            let me = this;
            me.$emit("spesaExtraDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteSpesaExtraError(error) {
            let me = this;
            me.$emit("spesaExtraDelete", error);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        /* onInputIva(value) {
            console.log(value);
            let me = this;
            me.codiceIvaOptions.forEach((element) => {
                if (element.codiceIva === value) {
                    this.jsonDataSpeseExtra.aliquotaIva = element.aliquotaIva;
                    this.jsonDataSpeseExtra.descrizioneIva = element.descrizioneIva;
                    console.log(value);

                    console.log(element.codiceIva);
                }
            });
        }, */

        onCodiceIvaChange(value) {
            let me = this;
            me.selectedCodiceIva = me.codiceIvaOptions.find((s) => s.codiceIva === value);
            if (me.selectedCodiceIva) {
                me.aliquotaIva = me.selectedCodiceIva.aliquotaIva;
            }
        },
    },
};
</script>
